import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-dashboard-entry-reentry-leads',
  storeModule.createStoreModule('leads-receptions-dashboard-entry-reentry-leads', {
    fetchListURL: 'leads-receptions/dashboard/entry-reentry-leads'
  })
)
